const o = (e, n) => {
  const r = {};
  for (const t in e)
    Object.prototype.hasOwnProperty.call(e, t) && !n.includes(t) && (r[t] = e[t]);
  return r;
};
export {
  o as omit
};
//# sourceMappingURL=index.js.map
